import { useState } from "react";

// Lógica compartida de reserva: fechas de rango + huéspedes + panel abierto + validación.
// La apariencia NO se comparte: cada formulario conserva sus propias clases.
export function useBooking() {
    const [arrival, setArrival] = useState("");
    const [departure, setDeparture] = useState("");
    const [adults, setAdults] = useState(2);
    const [children, setChildren] = useState(0);
    const [panel, setPanel] = useState(null); // 'dates' | 'guests' | null

    const openPanel = (p) => setPanel((cur) => (cur === p ? null : p));
    const closePanel = () => setPanel(null);

    const setRange = (startISO, endISO) => {
        setArrival(startISO);
        setDeparture(endISO);
    };

    // Validación manual (los inputs son readOnly: HTML ignora `required` en readOnly)
    const validateSubmit = (e) => {
        if (!arrival || !departure || departure <= arrival) {
            e.preventDefault();
            setPanel("dates");
            return false;
        }
        return true;
    };

    return {
        arrival,
        departure,
        adults,
        children,
        panel,
        openPanel,
        closePanel,
        setRange,
        setGuests: (a, c) => {
            setAdults(a);
            setChildren(c);
        },
        validateSubmit,
    };
}

const SHORT_LOCALE = { es: "es-MX", en: "en-US" };

// "22 ago → 27 ago" / "Aug 22 → Aug 27"
export function formatRange(startISO, endISO, lang) {
    if (!startISO || !endISO) return "";
    const fmt = (iso) => {
        const [y, m, d] = iso.split("-").map(Number);
        return new Date(y, m - 1, d).toLocaleDateString(SHORT_LOCALE[lang] || "es-MX", { day: "numeric", month: "short" });
    };
    return `${fmt(startISO)} → ${fmt(endISO)}`;
}
